import {
  deserify,
  FAAssessmentTopicPopup,
  formatRemainingTime,
  getLastSignificantState,
  HomeworkTimer,
  InfoBarWithDivider,
  InstructionsPanel,
  InstructionsPanelWithArray,
  IStyles,
  Loader,
  PrimaryButton,
  pxToRem,
  pxTovW,
  shuffleListWithSeed,
  theme,
  useCommonServiceClientContext,
} from '@geneo2-web/shared-ui';
import { Box, Button, Chip, Typography, useMediaQuery } from '@mui/material';
import { AssessmentContent } from '@protos/learning_management/lms.assessment.common.apis_pb';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import { useDownloadContext } from 'apps/student/src/app/Context/DownloadContextProviderV2';
import { useGlobalContext } from 'apps/student/src/app/Context/GlobalContextProvider';
import {
  useAppDispatch,
  useAppSelector,
} from 'apps/student/src/reduxStore/reduxHooks';
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { use } from 'video.js/dist/types/tech/middleware';
import {
  checkFeatureData,
  updateAssessmentContentWithMarks,
} from '../../utils_homework/homeworkUtil';
import { StudentLoginResponseType } from '@protos/user_management/ums.login.apis_pb';
import {
  AssessmentSessionModeEnum,
  AssignmentConfigEnum,
  MarkingSchemeEnum,
  MultiSubjectSection,
  TaskQuestionInfo,
  TaskStudentAttemptStatusEnum,
} from '@protos/learning_management/lms.db_pb';
import { calculateCompletedTasks, extraInstructions } from '../../HwStartCover';
import { SubjectAssessmentCard } from '../components/SubjectAssessmentCard';
import {
  getSubjectColorBySubjectId,
  getSubjectImageBySubjectId,
} from '../../utils_assessment/assessmentUtils';
import { SelectedSectionAssessment } from 'libs/shared-ui/src/components/composites/FAAssessmentTopicPopup';
import {
  setActiveAssessmentContent,
  setActiveAssessmentId,
  setActiveAssessmentSessionId,
  setActiveAssessmentStudentResponse,
  setActiveSectionNumber,
  setAllAnswers,
  setSelectedAssessmentData,
} from '../reducer/multisubjectFA.slice';
import {
  FA_ACTIVE_ASSESSMENT,
  HOME,
  HOMEWORK_STUDENT_DASHBOARD,
} from '../../../../routeHandling/RoutesNomenclature';
import { Timestamp } from '@bufbuild/protobuf';
import { setToastInfo } from '../../../Home/reducer/homeDashboard.slice';
import { interactionEvent } from '../../../Auth/Login/login_logout.events';
import { setProctoringViolationsSummary } from '../../reducer/homework.slice';
import {
  AssessmentStudentResponse,
  AssessmentStudentResponseV2,
  MultiSubjectMetrics,
} from '@protos/learning_management/lms.assessment.student.apis_pb';
import { StaticTimer } from '../components/StaticTimer';
import { ProctoringInfoDisplay } from '../../HwStartCover/component/ProctoringInfoDisplay';
const styles: IStyles = {
  root: {
    // border: '1px solid black',
    boxSizing: 'border-box',
    p: {
      xs: `${pxToRem(20)} ${pxToRem(10)}`,
      md: `${pxTovW(20)} ${pxTovW(20)}`,
      lg: `${pxTovW(27)} ${pxTovW(410)} ${pxTovW(92)} ${pxTovW(240)}`,
    },
    bgcolor: 'neutral.lightOrange',
    minHeight: '90vh',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(20), md: pxTovW(40) },
  },
};
export default function FAStartCover() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { isIpadOnly } = useGlobalContext();
  const { isOffline } = useDownloadContext();
  const {
    LmsHomeworkCommonAPIServiceV1ClientWithStatusCodeHandler,
    LmsAssessmentStudentApiServiceV1ClientWithStatusCodeHandler,
    LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler,
    LmsAssessmentStudentApiServiceV2ClientWithStatusCodeHandler,
  } = useCommonServiceClientContext();
  const homework_end_path = useAppSelector(
    (state) => state.homework.homework_end_path
  );
  const assessment_id =
    new URLSearchParams(location.search).get('assessmentId') || undefined;
  const { userInfo } = deserify(useAppSelector((state) => state.auth));
  const { active_assessment_student_response, active_assessment_content } =
    deserify(useAppSelector((state) => state.multisubjectFA));
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [loading, setLoading] = useState<'loading' | 'completed' | 'error'>(
    'completed'
  );
  // const [activeAssessmentContent, setActiveAssessmentContent] = useState<
  //   AssessmentContent | undefined
  // >(undefined);
  const [selectedAssessment, setSelectedAssessment] = useState<
    SelectedSectionAssessment | undefined
  >();
  const [chapterListPopup, setChapterListPopup] = useState(false);
  const { setSelectedFunction } = useGlobalContext();
  const activeAssessmentContent =
    active_assessment_content && assessment_id
      ? active_assessment_content[assessment_id]
      : undefined;
  const totalTasks = activeAssessmentContent?.assessmentContent.length || 0;
  const activeAssessmentStudentResponse =
    active_assessment_student_response && assessment_id
      ? active_assessment_student_response[assessment_id]
      : undefined;

  // const initialTimerValue = useMemo(() => {
  //   return (
  //     (activeAssessmentContent?.assessment?.estimatedTimeInMin || 0) * 60 -
  //     (activeAssessmentStudentResponse?.attemptSpentTimeInSecs || 0)
  //   );
  // }, [activeAssessmentContent, activeAssessmentStudentResponse]);
  const initialTimerValue = useMemo(() => {
    const total =
      (activeAssessmentContent?.assessment?.estimatedTimeInMin || 0) * 60;

    const spent = activeAssessmentStudentResponse?.attemptSpentTimeInSecs || 0;

    const reattempt = checkFeatureData({
      assignmentConfigInfo: activeAssessmentContent?.assessment?.assignmentInfo,
      userInfo,
    }).reattempt;
    const status = activeAssessmentStudentResponse?.assessmentAttemptStatus;

    const isTimedOutOrCompleted =
      status === TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_TIMED_OUT ||
      status === TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_COMPLETED;

    return reattempt && isTimedOutOrCompleted ? total : total - spent;
  }, [activeAssessmentContent, activeAssessmentStudentResponse, userInfo]);

  const onBackClick = () => {
    navigate(homework_end_path ? homework_end_path : HOME);
    dispatch(setActiveAssessmentSessionId(undefined));
    // navigate(homework_end_path ? homework_end_path : HOME);
    // dispatch(setHomeworkEndPath(undefined));
    // dispatch(setActiveHomeworSessionId(undefined));
  };
  const chapterListPopupHandler = (section: MultiSubjectSection) => {
    setSelectedAssessment({
      section,
      assessment: activeAssessmentContent?.assessment,
    });

    setChapterListPopup(true);
  };
  useEffect(() => {
    fetchAssessmentContent();
    dispatch(setAllAnswers([]));
    setSelectedFunction(() => onBackClick);
    return () => {
      setSelectedFunction(null);
    };
  }, []);

  const assessmentStatusTimedOut =
    activeAssessmentStudentResponse?.assessmentAttemptStatus ===
    TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_TIMED_OUT;
  const completedTasks = calculateCompletedTasks(
    activeAssessmentStudentResponse,
    assessmentStatusTimedOut
  );
  const fetchAssessmentContent = async () => {
    if (
      !userInfo?.studentProfileId ||
      !assessment_id ||
      isNaN(Number(assessment_id))
    ) {
      return;
    }
    try {
      setLoading('loading');
      const assessmentContent =
        await LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchAssessmentContent(
          {
            personId: userInfo.studentProfileId,
            personType: ProfileRolesEnum.PROFILE_ROLE_STUDENT,
            assessmentId: (assessment_id ? BigInt(assessment_id) : undefined),
          }
        );
      const studentAssessmentResponse =
        await LmsAssessmentStudentApiServiceV2ClientWithStatusCodeHandler.fetchStudentAssessmentResponse(
          {
            studentId: userInfo.studentProfileId,
            assessmentId: (assessment_id ? BigInt(assessment_id) : undefined),
          }
        );
      const assessmentData = updateAssessmentContentWithMarks(
        assessmentContent.data
      );
      dispatch(
        setActiveAssessmentId(
          assessment_id ? assessment_id.toString() : undefined
        )
      );
      dispatch(
        setActiveAssessmentContent({
          assessmentId: (assessment_id ? BigInt(assessment_id) : undefined),
          content: assessmentData,
        })
      );
      dispatch(
        setActiveAssessmentStudentResponse({
          assessmentId: (assessment_id ? BigInt(assessment_id) : undefined),
          response: studentAssessmentResponse.data,
        })
      );
      dispatch(
        setSelectedAssessmentData({
          assessmentId: assessmentData?.questionsSequenceInfo?.homeworkId,
          questionIds: assessmentData?.questionsSequenceInfo?.questionIds,
          resumeCheck: completedTasks > 0 && completedTasks < totalTasks,
          reattemptedCheck: completedTasks >= totalTasks,
          SubmissionType: assessmentData?.assessment?.submissionType,
          elapsedTime:
            completedTasks !== totalTasks
              ? studentAssessmentResponse.data?.attemptSpentTimeInSecs
              : 0,
        })
      );

      setLoading('completed');
    } catch (err) {
      console.error(err);
      setLoading('error');
      dispatch(
        setToastInfo({
          label: 'Error while fetching assessment info',
          variant: 'error',
          open: true,
        })
      );
      dispatch(
        setActiveAssessmentContent({
          assessmentId: (assessment_id ? BigInt(assessment_id) : undefined),
          content: undefined,
        })
      );
      dispatch(
        setActiveAssessmentStudentResponse({
          assessmentId: (assessment_id ? BigInt(assessment_id) : undefined),
          response: undefined,
        })
      );
    } finally {
      setLoading('completed');
    }
  };
  const requestFullscreen = async (): Promise<boolean> => {
    // Check if already in fullscreen
    if (
      document.fullscreenElement ||
      (document as any).webkitFullscreenElement ||
      (document as any).msFullscreenElement
    ) {
      return true;
    }

    const element = document.documentElement;

    try {
      if (element.requestFullscreen) {
        // Standard API
        await element.requestFullscreen();
        return true;
      } else if ((element as any).webkitRequestFullscreen) {
        // Safari
        (element as any).webkitRequestFullscreen();
        // Give it a moment to activate
        await new Promise((resolve) => setTimeout(resolve, 100));
        return true;
      } else if ((element as any).msRequestFullscreen) {
        // IE/Edge
        (element as any).msRequestFullscreen();
        // Give it a moment to activate
        await new Promise((resolve) => setTimeout(resolve, 100));
        return true;
      }
      console.warn('Fullscreen API not supported in this browser');
      return false;
    } catch (err: any) {
      console.error('Error attempting to enable fullscreen:', err);
      return false;
    }
  };
  const startButtonHandler = async (section: number) => {
    if (
      new Timestamp(
        activeAssessmentContent?.assessment?.assessmentTargetDate
      ).toDate() < new Date(Date.now())
    ) {
      dispatch(
        setToastInfo({
          label: `Apologies, Deadline for ${
            completedTasks === 0 ||
            !completedTasks ||
            completedTasks < totalTasks
              ? ''
              : 're'
          } attempt has passed.`,
          variant: 'error',
          open: true,
        })
      );
      return;
    }
    if (!assessment_id || !userInfo?.studentProfileId) {
      return;
    }
    const sessionMode =
      activeAssessmentStudentResponse?.assessmentAttemptStatus ===
        TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_COMPLETED ||
      activeAssessmentStudentResponse?.assessmentAttemptStatus ===
        TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_TIMED_OUT
        ? AssessmentSessionModeEnum.ASSESSMENT_SESSION_MODE_REATTEMPT
        : activeAssessmentStudentResponse?.assessmentAttemptStatus ===
          TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_IN_PROGRESS
        ? AssessmentSessionModeEnum.ASSESSMENT_SESSION_MODE_RESUME
        : AssessmentSessionModeEnum.ASSESSMENT_SESSION_MODE_FIRST_ATTEMPT;

    try {
      setLoading('loading');
      const hwSession =
        await LmsAssessmentStudentApiServiceV1ClientWithStatusCodeHandler.createStudentAssessmentSession(
          {
            studentId: userInfo.studentProfileId,
            assessmentId: (assessment_id ? BigInt(assessment_id) : undefined),
            sessionMode: sessionMode,
            sessionStatus:
              TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_IN_PROGRESS,
            clientTimestamp: Timestamp.fromDate(new Date()),
          }
        );
      if (
        sessionMode !== AssessmentSessionModeEnum.ASSESSMENT_SESSION_MODE_RESUME
      ) {
        dispatch(
          setActiveAssessmentStudentResponse({
            assessmentId: (assessment_id ? BigInt(assessment_id) : undefined),
            response: undefined,
          })
        );
      }
      if (assessmentStatusTimedOut) {
        dispatch(
          setActiveAssessmentStudentResponse({
            assessmentId: (assessment_id ? BigInt(assessment_id) : undefined),
            response: undefined,
          })
        );
      }

      // Only shuffle questions and dispatch if hwSession.attemptNumber is available
      if (
        hwSession?.attemptNumber &&
        checkFeatureData({
          assignmentConfigInfo:
            activeAssessmentContent?.assessment?.assignmentInfo,
          userInfo: userInfo,
        }).shuffling
      ) {
        const activeHomeworkContent =
          active_assessment_content && assessment_id
            ? active_assessment_content[assessment_id]
            : undefined;
        const sections = activeAssessmentContent?.multiSubjectSections || [];
        const taskQuestionInfoCopy =
          activeAssessmentContent?.questionsSequenceInfo?.taskQuestionInfo ||
          [];
        const allSectionsWithOrder: MultiSubjectSection[] = sections
          .slice()
          .sort((a, b) => (a.sectionNo || 0) - (b.sectionNo || 0));

        const questionSectionMap = new Map<string, number | undefined>();

        allSectionsWithOrder.forEach((section) => {
          if (section.sectionNo === undefined) return;
          section.multiSubjectSubSections?.forEach((sub) => {
            sub.subSectionMetaData?.forEach((q) => {
              questionSectionMap.set(q.questionId, section.sectionNo!);
            });
          });
        });
        //create individual sections list
        const allSectionsQuestionsList: TaskQuestionInfo[][] =
          allSectionsWithOrder.map((section) => {
            return taskQuestionInfoCopy.filter((q) => {
              if (!q.questionId) return false;
              return questionSectionMap.get(q.questionId) === section.sectionNo;
            });
          });
        // [/* section 1 questions */],
        // [/* section 2 questions */],
        const seed =
          Number(userInfo.studentProfileId) * hwSession.attemptNumber;

        //shuffle individual sections
        const shuffledSections: TaskQuestionInfo[][] =
          allSectionsQuestionsList.map((sectionQuestions, index) => {
            // optional: unique seed per section
            const sectionSeed = seed + index;

            return shuffleListWithSeed(sectionQuestions, sectionSeed);
          });
        const flattenedShuffledList = shuffledSections.flat();

        const sequenceUpdate = flattenedShuffledList.map((q, index) => ({
          ...q,
          sequence: index + 1,
        }));
        const updatedHomeworkContent = {
          ...activeHomeworkContent,
          questionsSequenceInfo: {
            ...activeHomeworkContent?.questionsSequenceInfo,
            taskQuestionInfo: sequenceUpdate,
          },
        };
        dispatch(
          setActiveAssessmentContent({
            assessmentId: (assessment_id ? BigInt(assessment_id) : undefined),
            content: updatedHomeworkContent as AssessmentContent,
          })
        );
      } else {
        console.log(
          'hwSession.attemptNumber is missing, skipping randomization and dispatch.'
        );
      }

      if (hwSession.sessionId) {
        dispatch(setActiveAssessmentSessionId(hwSession.sessionId));
      } else {
        dispatch(
          setToastInfo({
            label: 'session id is missing',
            variant: 'error',
            open: true,
          })
        );
        return;
      }
      await interactionEvent({
        url: 'Student_FAassessment-start-cover',
        context: 'Homework',
        name:
          completedTasks === 0
            ? "LET'S START"
            : completedTasks >= totalTasks
            ? 'Re-attempt'
            : 'RESUME',
        homeworkSesssionId: hwSession.sessionId?.toString(),
        isOffline: isOffline,
      });

      if (
        active_assessment_content?.[
          assessment_id || ''
        ]?.assessment?.assignmentInfo?.find(
          (info) =>
            info.configName ===
            AssignmentConfigEnum.ASSIGNMENT_CONFIG_PROCTORING
        )?.isEnabled
      ) {
        dispatch(setProctoringViolationsSummary(undefined));
        // Request fullscreen and wait for it to complete before navigating
        await requestFullscreen();
        // Add a small delay to ensure fullscreen is fully activated before navigation
        await new Promise((resolve) => setTimeout(resolve, 200));
      }

      dispatch(setActiveSectionNumber(section));
      navigate(`${FA_ACTIVE_ASSESSMENT}?assessmentId=${assessment_id}`);
      setLoading('completed');
    } catch (err: any) {
      setLoading('completed'); //bcz error toast is already there
      console.log('err:2', err.message);
      dispatch(
        setToastInfo({
          label: `${
            err?.message
              ? err.message.replace(/.*\]\s*/, '').trim()
              : 'Homework Start Failed'
          }`,
          variant: 'error',
          open: true,
        })
      );
    }
  };
  console.log('loading', loading);
  if (loading === 'loading') {
    return <Loader />;
  }

  return (
    <Box sx={styles.root}>
      <Box sx={styles.container}>
        <Box
          display="flex"
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Typography
            variant="h1"
            sx={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {activeAssessmentContent?.assessment?.assessmentTitle ||
              'My Formative Assessment'}
          </Typography>

          {checkFeatureData({
            assignmentConfigInfo:
              activeAssessmentContent?.assessment?.assignmentInfo,
            userInfo: userInfo,
          }).timed && (
            <Box>
              {isMobile && activeAssessmentStudentResponse && (
                <StaticTimer time={initialTimerValue} />
              )}
            </Box>
          )}
          {/* <Typography variant="smallText">
            {activeAssessmentStudentResponse?.assessmentAttemptStatus &&
              AssessmentSessionModeEnum[
                activeAssessmentStudentResponse?.assessmentAttemptStatus
              ]}
          </Typography> */}
          {/* <PrimaryButton>Submit</PrimaryButton> */}
        </Box>
        <Box
          display={'flex'}
          flexDirection={isMobile ? 'column' : 'row'}
          justifyContent={'space-between'}
          alignItems={isMobile ? 'flex-start' : 'center'}
          mb={4}
        >
          <Box
            display={'flex'}
            flexDirection={isMobile ? 'column' : 'row'}
            gap={{ xs: pxToRem(15) }}
            flexWrap={'wrap'}
          >
            <Typography variant="h2" fontWeight={500}>
              Your Subjects for Assessment
            </Typography>
            <Box
              display={'flex'}
              alignItems={'center'}
              gap={{ xs: pxToRem(5) }}
            >
              <Chip
                label={`Class ${activeAssessmentContent?.assessment?.class}`}
                variant="outlined"
                color="primary"
                sx={{ bgcolor: '#E1F5FE', color: '#039BE5', fontWeight: 700 }}
              />
              <Chip
                label={`Total Marks: ${activeAssessmentContent?.assessment?.maxMarks}`}
                variant="outlined"
                color="primary"
                sx={{ bgcolor: '#E8F5E9', color: '#43A047', fontWeight: 700 }}
              />
              <Chip
                label="Formative Assessment"
                sx={{ bgcolor: '#007CDC', color: '#FFF', fontWeight: 700 }}
              />
            </Box>
          </Box>
          {checkFeatureData({
            assignmentConfigInfo:
              activeAssessmentContent?.assessment?.assignmentInfo,
            userInfo: userInfo,
          }).timed && (
            <Box>
              {!isMobile && activeAssessmentStudentResponse && (
                <StaticTimer time={initialTimerValue} />
              )}
            </Box>
          )}
        </Box>
        <Box>
          {activeAssessmentContent?.assessment?.assignmentInfo?.find(
            (info) =>
              info.configName ===
              AssignmentConfigEnum.ASSIGNMENT_CONFIG_PROCTORING
          )?.isEnabled ? (
            <ProctoringInfoDisplay />
          ) : null}
        </Box>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            flexDirection: { xs: 'column-reverse', md: 'row' },

            gap: 2,
          }}
        >
          <Box width={{ xs: '100', md: '40%' }}>
            {renderInstructionPanel(activeAssessmentContent, userInfo)}
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 3,
            }}
            width={{ xs: '100', md: '50%' }}
          >
            {activeAssessmentContent?.multiSubjectSections.map(
              (section, index) => {
                const attempted = getAttemptedQuestionsCount(
                  section,
                  activeAssessmentStudentResponse
                );
                const metricsLength =
                  activeAssessmentStudentResponse?.multiSubjectMetrics
                    ?.length ?? 0;
                return (
                  <SubjectAssessmentCard
                    key={index}
                    status={
                      metricsLength <= 1
                        ? getAttemptStatusDirectly(
                            activeAssessmentStudentResponse?.assessmentAttemptStatus
                          )
                        : getAttemptStatus(
                            section,
                            activeAssessmentStudentResponse?.multiSubjectMetrics
                          )
                    }
                    section={section}
                    subjectColor={getSubjectColorBySubjectId(
                      section.subjectId,
                      userInfo?.learnSubjects
                    )}
                    subjectIcon={getSubjectImageBySubjectId(
                      section.subjectId,
                      userInfo?.learnSubjects
                    )}
                    onStartTest={() =>
                      startButtonHandler(section.sectionNo || 0)
                    }
                    chapterListPopupHandler={chapterListPopupHandler}
                    attempted={attempted}
                    ctaDisable={
                      activeAssessmentStudentResponse?.assessmentAttemptStatus ===
                        TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_COMPLETED &&
                      !checkFeatureData({
                        assignmentConfigInfo:
                          activeAssessmentContent?.assessment?.assignmentInfo,
                        userInfo: userInfo,
                      }).reattempt
                    }
                    taskCompletedDate={
                      activeAssessmentStudentResponse?.taskCompletedDate
                    }
                  />
                );
              }
            )}
          </Box>
        </Box>
      </Box>
      <FAAssessmentTopicPopup
        data={selectedAssessment}
        open={chapterListPopup}
        handleClose={() => setChapterListPopup(false)}
      />
    </Box>
  );
}

const renderInstructionPanel = (
  activeHomeworkContent: AssessmentContent | undefined,
  userInfo?: StudentLoginResponseType
) => {
  const homeworkInstructions =
    activeHomeworkContent?.assessment?.assessmentInstructions;

  if (!homeworkInstructions || !Array.isArray(homeworkInstructions))
    return null; // Handle no instructions gracefully
  const timedtest = checkFeatureData({
    assignmentConfigInfo: activeHomeworkContent?.assessment?.assignmentInfo,
    userInfo: userInfo,
  }).timed;
  const reattemptConfig = checkFeatureData({
    assignmentConfigInfo: activeHomeworkContent?.assessment?.assignmentInfo,
    userInfo: userInfo,
  }).reattempt;
  const configBasedInstructions = extraInstructions({
    timeTest: timedtest,
    reattempt: reattemptConfig,
  });
  if (homeworkInstructions.length === 1) {
    const singleInstruction = homeworkInstructions[0];
    const isHtmlString = /<\/?[a-z][\s\S]*>/i.test(singleInstruction);

    if (isHtmlString) {
      return (
        <InstructionsPanel
          customSx={{
            display: 'flex',
            flexGrow: 1,
            width: { xs: '100%', lg: pxTovW(590) },
            gap: { xs: pxToRem(20), md: pxTovW(20) },
          }}
          title="Instructions:"
          Katexvalue={singleInstruction}
        />
      );
    } else {
      return (
        <InstructionsPanelWithArray
          customSx={{
            display: 'flex',
            flexGrow: 1,
            width: { xs: '100%', md: pxTovW(900), lg: pxTovW(590) },
            gap: { xs: pxToRem(40), md: pxTovW(20) },
          }}
          title="Instructions:"
          stringArrayValue={[...singleInstruction, ...configBasedInstructions]} // Pass as an array
        />
      );
    }
  } else {
    return (
      <InstructionsPanelWithArray
        customSx={{
          display: 'flex',
          flexGrow: 1,
          width: { xs: '100%', md: pxTovW(900), lg: pxTovW(590) },
        }}
        title="Instructions:"
        stringArrayValue={[...homeworkInstructions, ...configBasedInstructions]}
        markingSchemeAccordionDisplay={activeHomeworkContent.multiSubjectSections.some(
          (e) =>
            e.markingSchemeType === MarkingSchemeEnum.MARKING_SCHEME_JEE
              ? true
              : false
        )}
      />
    );
  }
};

const getAttemptStatus = (
  section?: MultiSubjectSection,
  metrics?: MultiSubjectMetrics[]
): 'start' | 'resume' | 'complete' => {
  const selectedSectionAttemptStatus = metrics?.find(
    (e) => e.sectionNo === section?.sectionNo
  )?.assessmentSectionAttemptStatus;
  if (!selectedSectionAttemptStatus) {
    return 'start';
  }
  switch (selectedSectionAttemptStatus) {
    case TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_PENDING:
      return 'start';
    case TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_PAUSED:
    case TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_IN_PROGRESS:
      return 'resume';
    case TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_COMPLETED:
    case TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_TIMED_OUT: //should not come
      return 'complete';
    default:
      return 'start';
  }
};
const getAttemptStatusDirectly = (
  selectedSectionAttemptStatus?: TaskStudentAttemptStatusEnum
): 'start' | 'resume' | 'complete' => {
  if (!selectedSectionAttemptStatus) {
    return 'start';
  }
  switch (selectedSectionAttemptStatus) {
    case TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_PENDING:
      return 'start';
    case TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_PAUSED:
    case TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_IN_PROGRESS:
      return 'resume';
    case TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_COMPLETED:
    case TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_TIMED_OUT: //should not come
      return 'complete';
    default:
      return 'start';
  }
};

const getAttemptedQuestionsCount = (
  section: MultiSubjectSection,
  studentResponse?: AssessmentStudentResponse
): number => {
  if (!section || !studentResponse) return 0;

  // Get all questionIds in this section
  const questionIds =
    section.multiSubjectSubSections?.flatMap((sub) =>
      sub.subSectionMetaData?.map((q) => q.questionId)
    ) || [];

  let attemptedCount = 0;

  questionIds.forEach((qId) => {
    const questionResponse = studentResponse.responses.find(
      (r) => r.questionId === qId
    );

    const lastState = getLastSignificantState(questionResponse?.responses);

    if (lastState.status === 'lastAnswered') {
      attemptedCount++;
    }
  });

  return attemptedCount;
};
